module.exports = __webpack_public_path__ + "img/banner-overseas-student.ae268d17.png";